import { useContext } from 'react';

import { DatadogContext } from '../DatadogContext';

export const useDatadogContext = () => {
  const context = useContext(DatadogContext);
  const { datadogLogs } = context ?? {};

  // don't error if not initialized
  return { datadogLogs };
};
